import React, { useEffect, useState } from "react";
import { Box, Chip, IconButton } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import StyledDataGrid from "./bento/StyledDataGrid";
import { DataGridCustomToolbarClientMode } from "./DataGridCustomToolbar";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import moment from "moment-timezone";
import { isMobile } from "react-device-detect";
import { user } from "localStorage";
import TrackingDetailDialog from "./TrackingDetialDialog.";
import { Link } from "react-router-dom";

const PackageDataGrid = ({
  packages,
  page,
  setPage,
  pageSize,
  setPageSize,
  search,
  setSearch,
  // Optional — when provided, an Edit column is appended so callers can wire
  // up their own PackageEditDialog. Opt-in so the many other pages reusing
  // this grid (packageList, customerInfo, gallery, ...) are unaffected.
  onEdit,
}) => {
  const _user = user();
  const isAgentUser = _user.role === "agent";
  const [filteredRows, setFilteredRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [trackingNumber, setTrackingNumber] = useState("");

  function filterPackage(dataArr, searchValue) {
    if (dataArr) {
      let newArr = dataArr.slice();
      if (searchValue) {
        newArr = newArr.filter((element) => {
          return (
            (element.tracking &&
              element.tracking.toLowerCase().includes(searchValue.toLowerCase())) ||
            (element.description &&
              element.description.toLowerCase().includes(searchValue.toLowerCase())) ||
            (element.customer &&
              element.customer.name.toLowerCase().includes(searchValue.toLowerCase())) ||
            (element.orderId &&
              element.orderId.toLowerCase().includes(searchValue.toLowerCase())) ||
            (element._id.customer &&
              element._id.customer.whatsapp.toLowerCase().includes(searchValue.toLowerCase()))
          );
        });
      }
      setFilteredRows(newArr);
    }
  }

  useEffect(() => {
    filterPackage(packages, search);
  }, [packages, search]);

  const columns = [
    { field: "_id", headerName: "ID", flex: 1, hide: true },
    {
      field: "customer",
      headerName: "Customer",
      flex: 0.5,
      valueGetter: (params) => params.row.customer && params.row.customer.name,
    },
    { field: "orderId", headerName: "Order ID", flex: 0.7, hide: true },
    {
      field: "tracking",
      headerName: "Tracking",
      flex: 0.5,
      renderCell: (cellValues) => (
        <Link
          component="button"
          color="secondary"
          underline="hover"
          onClick={() => {
            setTrackingNumber(cellValues.row.tracking);
            setOpen(true);
          }}
        >
          {cellValues.row.tracking}
        </Link>
      ),
    },
    { field: "description", headerName: "Description", flex: 1.5, hide: isMobile },
    { field: "routeId", headerName: "Route ID", flex: 0.5, hide: isMobile },
    { field: "amount", headerName: "Amount", flex: 0.3, hide: true },
    { field: "station", headerName: "Station", flex: 0.3, hide: isMobile },
    { field: "status", headerName: "Status", flex: 0.4, hide: true },
    {
      field: "fragile",
      headerName: "Fragile",
      flex: 0.3,
      hide: true,
      sortable: false,
      renderCell: (cellValues) =>
        cellValues.row.transitCheckRequired || cellValues.row.finalCheckRequired ? (
          <Chip label="Fragile" size="small" color="warning" variant="outlined" />
        ) : null,
    },
    {
      field: "isCOD",
      headerName: "COD",
      flex: 0.3,
      hide: true,
      renderCell: (cellValues) =>
        cellValues.row.isCOD ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        ),
    },
    { field: "shippingFee", headerName: "ຄ່າບໍລິການ", flex: 0.3, hide: isMobile || isAgentUser },
    { field: "finalShippingFee", headerName: "Final Fee", flex: 0.3, hide: !isAgentUser || isMobile },
    {
      field: "isSelfOrder",
      headerName: "ສັ່ງເອງ",
      flex: 0.3,
      hide: true,
      renderCell: (cellValues) =>
        cellValues.row.isSelfOrder ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        ),
    },
    {
      field: "isSubCustomer",
      headerName: "ລູກຄ້າຕົວແທນ",
      flex: 0.3,
      hide: true,
      renderCell: (cellValues) =>
        cellValues.row.isSubCustomer ? (
          <CheckBoxIcon color="secondary" />
        ) : (
          <DoNotDisturbIcon color="primary" />
        ),
    },
    {
      field: "agentId",
      headerName: "ຕົວແທນ",
      flex: 0.3,
      hide: true,
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      flex: 0.7,
      valueGetter: (params) =>
        moment(params.row.updatedAt)
          .tz("Asia/Vientiane")
          .format("DD/MM/YYYY, h:mm:ss A"),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      flex: 0.7,
      // hide: true,
      valueGetter: (params) =>
        moment(params.row.createdAt)
          .tz("Asia/Vientiane")
          .format("DD/MM/YYYY, h:mm:ss A"),
    },
    ...(onEdit
      ? [
          {
            field: "edit",
            headerName: "",
            flex: 0.3,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
              <IconButton size="small" onClick={() => onEdit(params.row)}>
                <EditOutlinedIcon fontSize="small" />
              </IconButton>
            ),
          },
        ]
      : []),
  ];

  return (
    <Box
      height={"75vh"}
      sx={{
        marginLeft: isMobile ? "-0.5rem" : "0",
        marginRight: isMobile ? "-0.5rem" : "0",
      }}
    >
      <StyledDataGrid
        getRowId={(row) => row._id}
        rows={filteredRows || []}
        columns={columns}
        rowCount={filteredRows ? filteredRows.length : 0}
        rowsPerPageOptions={[20, 50, 100]}
        pagination
        page={page}
        pageSize={pageSize}
        paginationMode="client"
        sortingMode="client"
        filterMode="client"
        onPageChange={(newPage) => setPage(newPage)}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        components={{ Toolbar: DataGridCustomToolbarClientMode }}
        componentsProps={{
          toolbar: { search, setSearch },
        }}
        containerSx={{ height: "100%" }}
        autoHeight={false}
      />
      <TrackingDetailDialog
        open={open}
        onClose={() => setOpen(false)}
        trackingNumber={trackingNumber}
      />
    </Box>
  );
};

export default PackageDataGrid;